module.exports = __webpack_public_path__ + "static/media/1.94491420.png";